<div class="dashboard-content policy-management-page" style="padding: 120px 40px 50px">
  <div class="policy-management-container">
    
    <!-- Top Navigation & Breadcrumb -->
    <div class="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-2">
      <div class="d-flex align-items-center gap-2">
        <button type="button" class="btn btn-light back-btn" (click)="goBack()">
          <i class="fa-solid fa-arrow-left me-2"></i>
          <span>{{ 'policy-management.back-to-users' | translate }}</span>
        </button>
        <span class="breadcrumb-separator text-muted">/</span>
        <span class="text-muted" style="font-size: 13px; font-weight: 500;">
          {{ 'user-management.all-users' | translate }}
        </span>
        <span class="breadcrumb-separator text-muted">/</span>
        <span class="breadcrumb-current text-primary" style="font-size: 13px; font-weight: 600;">
          {{ 'policy-management.title' | translate }}
        </span>
      </div>

      <!-- Quick Preset & Export Actions -->
      <div class="d-flex align-items-center gap-2">
        <!-- Preset Dropdown -->
        <div class="dropdown">
          <button class="btn btn-outline-primary dropdown-toggle preset-btn" type="button" data-bs-toggle="dropdown" aria-expanded="false" [disabled]="!selectedUser || isLoadingPermissions">
            <i class="fa-solid fa-wand-magic-sparkles me-2"></i>
            <span>{{ 'policy-management.apply-preset' | translate }}</span>
          </button>
          <ul class="dropdown-menu dropdown-menu-end preset-menu shadow-sm">
            <li class="dropdown-header text-muted" style="font-size: 11px; text-transform: uppercase; font-weight: 600;">
              Policy Templates
            </li>
            <li *ngFor="let preset of presets">
              <a class="dropdown-item d-flex align-items-center gap-2 py-2" href="javascript:void(0)" (click)="applyPreset(preset)">
                <div class="preset-icon-wrap">
                  <i [class]="preset.icon"></i>
                </div>
                <div>
                  <div style="font-weight: 600; font-size: 13px; color: #101828;">{{ preset.nameKey | translate }}</div>
                  <div style="font-size: 11px; color: #667085;">{{ preset.descKey | translate }}</div>
                </div>
              </a>
            </li>
          </ul>
        </div>

        <!-- Export Dropdown -->
        <div class="dropdown">
          <button class="btn btn-light dropdown-toggle export-btn" type="button" data-bs-toggle="dropdown" aria-expanded="false" [disabled]="userPermissions.length === 0">
            <i class="fa-solid fa-file-export me-1"></i>
            <span>{{ 'common.export' | translate }}</span>
          </button>
          <ul class="dropdown-menu dropdown-menu-end shadow-sm">
            <li>
              <a class="dropdown-item d-flex align-items-center gap-2" href="javascript:void(0)" (click)="exportPDF()">
                <i class="fa-solid fa-file-pdf text-danger"></i>
                <span>{{ 'policy-management.export-pdf' | translate }}</span>
              </a>
            </li>
            <li>
              <a class="dropdown-item d-flex align-items-center gap-2" href="javascript:void(0)" (click)="exportExcel()">
                <i class="fa-solid fa-file-excel text-success"></i>
                <span>{{ 'policy-management.export-excel' | translate }}</span>
              </a>
            </li>
          </ul>
        </div>

        <!-- Save Policy Button -->
        <button type="button" class="btn btn-primary px-4 save-main-btn position-relative"
          [disabled]="isSaving || isLoadingPermissions || !selectedUser" (click)="savePolicy()">
          <span *ngIf="isSaving" class="spinner-border spinner-border-sm me-2"></span>
          <i *ngIf="!isSaving" class="fa-solid fa-floppy-disk me-2"></i>
          <span>{{ (isSaving ? 'policy-management.saving' : 'policy-management.save-policy') | translate }}</span>
          <span *ngIf="hasUnsavedChanges" class="unsaved-badge-dot" title="You have unsaved changes"></span>
        </button>
      </div>
    </div>

    <!-- Header Section -->
    <div class="policy-header-card mb-4">
      <div class="row align-items-center">
        <div class="col-lg-7 col-md-12">
          <div class="d-flex align-items-center gap-3">
            <div class="header-icon-box">
              <i class="fa-solid fa-shield-halved"></i>
            </div>
            <div>
              <div class="d-flex align-items-center gap-2 flex-wrap">
                <h1 class="page-main-title mb-0">{{ 'policy-management.title' | translate }}</h1>
                <span class="security-badge">
                  <i class="fa-solid fa-lock me-1"></i>
                  Role-Based Access Control
                </span>
              </div>
              <p class="page-subtitle mb-0 mt-1">
                {{ 'policy-management.subtitle' | translate }}
              </p>
            </div>
          </div>
        </div>

        <!-- User Selector Section -->
        <div class="col-lg-5 col-md-12 mt-3 mt-lg-0">
          <div class="user-select-panel" *ngIf="users.length > 0">
            <label class="user-select-label">
              <i class="fa-solid fa-user-gear me-1"></i>
              {{ 'policy-management.select-user' | translate }}:
            </label>
            <div class="dropdown w-100">
              <button class="btn btn-user-select dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                type="button" data-bs-toggle="dropdown" aria-expanded="false">
                <div class="d-flex align-items-center gap-2 text-truncate">
                  <div class="user-avatar-mini">
                    <img *ngIf="selectedUser?.profile_image" [src]="selectedUser.profile_image" alt="">
                    <span *ngIf="!selectedUser?.profile_image">{{ (selectedUser?.name || selectedUser?.email || 'U').charAt(0).toUpperCase() }}</span>
                  </div>
                  <div class="text-start text-truncate">
                    <div class="user-select-name text-truncate">{{ selectedUser?.name || 'Selected User' }}</div>
                    <div class="user-select-email text-truncate">{{ selectedUser?.email || '-' }}</div>
                  </div>
                </div>
                <span class="badge user-role-pill ms-2">{{ selectedUser?.role || 'Sub-User' }}</span>
              </button>
              <ul class="dropdown-menu dropdown-menu-end user-dropdown-list w-100 shadow">
                <li *ngFor="let user of users">
                  <a class="dropdown-item user-option-item" [class.active]="user.id === selectedUserId"
                    href="javascript:void(0)" (click)="selectUser(user)">
                    <div class="d-flex align-items-center justify-content-between w-100">
                      <div class="d-flex align-items-center gap-2 text-truncate">
                        <div class="user-avatar-mini small">
                          <img *ngIf="user.profile_image" [src]="user.profile_image" alt="">
                          <span *ngIf="!user.profile_image">{{ (user.name || user.email || 'U').charAt(0).toUpperCase() }}</span>
                        </div>
                        <div class="text-truncate">
                          <div style="font-weight: 600; font-size: 13px; color: #101828;">{{ user.name || '-' }}</div>
                          <div style="font-size: 11px; color: #667085;">{{ user.email || '-' }}</div>
                        </div>
                      </div>
                      <span class="badge user-role-pill">{{ user.role || 'Sub-User' }}</span>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div *ngIf="users.length === 0 && !isLoadingUsers" class="alert alert-warning py-2 px-3 mb-0" style="font-size: 12.5px;">
            <i class="fa-solid fa-circle-exclamation me-1"></i>
            {{ 'policy-management.no-users' | translate }}
          </div>
        </div>
      </div>
    </div>

    <!-- Stats & Coverage Cards -->
    <div class="row g-3 mb-4">
      <!-- Card 1: Total Policies -->
      <div class="col-xl-3 col-md-6">
        <div class="stat-card">
          <div class="stat-icon-wrapper purple">
            <i class="fa-solid fa-layer-group"></i>
          </div>
          <div class="stat-content">
            <span class="stat-label">{{ 'policy-management.total-pages' | translate }}</span>
            <div class="d-flex align-items-baseline gap-2">
              <h2 class="stat-value">{{ totalCount }}</h2>
              <span class="stat-meta text-muted">Pages / Modules</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Card 2: Allowed Access -->
      <div class="col-xl-3 col-md-6">
        <div class="stat-card">
          <div class="stat-icon-wrapper green">
            <i class="fa-solid fa-shield-check"></i>
          </div>
          <div class="stat-content">
            <span class="stat-label">{{ 'policy-management.allowed-pages' | translate }}</span>
            <div class="d-flex align-items-baseline gap-2">
              <h2 class="stat-value text-success">{{ allowedCount }}</h2>
              <span class="stat-meta text-success" style="font-weight: 600;">Granted</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Card 3: Restricted Access -->
      <div class="col-xl-3 col-md-6">
        <div class="stat-card">
          <div class="stat-icon-wrapper red">
            <i class="fa-solid fa-shield-slash"></i>
          </div>
          <div class="stat-content">
            <span class="stat-label">{{ 'policy-management.restricted-pages' | translate }}</span>
            <div class="d-flex align-items-baseline gap-2">
              <h2 class="stat-value text-danger">{{ restrictedCount }}</h2>
              <span class="stat-meta text-danger" style="font-weight: 600;">Restricted</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Card 4: Access Coverage -->
      <div class="col-xl-3 col-md-6">
        <div class="stat-card">
          <div class="stat-icon-wrapper blue">
            <i class="fa-solid fa-chart-pie"></i>
          </div>
          <div class="stat-content w-100">
            <div class="d-flex align-items-center justify-content-between">
              <span class="stat-label">{{ 'policy-management.policy-coverage' | translate }}</span>
              <span class="coverage-status-tag" [ngClass]="coverageStatus.class">
                {{ coverageStatus.label }}
              </span>
            </div>
            <div class="d-flex align-items-baseline gap-2">
              <h2 class="stat-value">{{ coveragePercentage }}%</h2>
            </div>
            <div class="progress coverage-progress mt-2">
              <div class="progress-bar" role="progressbar" [style.width.%]="coveragePercentage"
                [style.background]="coveragePercentage === 100 ? '#10B981' : (coveragePercentage > 50 ? '#5304FB' : '#F59E0B')">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Main Content Card: Policies List & Controls -->
    <div class="luqta-card main-policy-card">
      
      <!-- Filter Toolbar -->
      <div class="policy-toolbar">
        <div class="row align-items-center g-3">
          
          <!-- Search input -->
          <div class="col-lg-4 col-md-6">
            <div class="search-input-box">
              <i class="fa-solid fa-magnifying-glass search-icon"></i>
              <input type="text" class="form-control" [(ngModel)]="searchTerm" (input)="onSearchChange()"
                [placeholder]="'policy-management.search-placeholder' | translate" />
              <i class="fa-solid fa-xmark clear-icon" *ngIf="searchTerm" (click)="searchTerm = ''; applyFilter()"></i>
            </div>
          </div>

          <!-- Status filter pills -->
          <div class="col-lg-4 col-md-6">
            <div class="status-filter-group">
              <button type="button" class="btn filter-chip" [class.active]="statusFilter === 'all'"
                (click)="statusFilter = 'all'; applyFilter()">
                {{ 'policy-management.filter-all' | translate }} ({{ totalCount }})
              </button>
              <button type="button" class="btn filter-chip allowed" [class.active]="statusFilter === 'allowed'"
                (click)="statusFilter = 'allowed'; applyFilter()">
                <i class="fa-solid fa-check me-1"></i>
                {{ 'policy-management.filter-allowed' | translate }} ({{ allowedCount }})
              </button>
              <button type="button" class="btn filter-chip restricted" [class.active]="statusFilter === 'restricted'"
                (click)="statusFilter = 'restricted'; applyFilter()">
                <i class="fa-solid fa-lock me-1"></i>
                {{ 'policy-management.filter-restricted' | translate }} ({{ restrictedCount }})
              </button>
            </div>
          </div>

          <!-- Bulk Actions & View Switcher -->
          <div class="col-lg-4 col-md-12 d-flex justify-content-lg-end align-items-center gap-2 flex-wrap">
            <button type="button" class="btn btn-sm btn-outline-success action-btn" (click)="grantAll()" title="Grant all page permissions">
              <i class="fa-solid fa-check-double me-1"></i>
              {{ 'policy-management.grant-all' | translate }}
            </button>
            <button type="button" class="btn btn-sm btn-outline-danger action-btn" (click)="revokeAll()" title="Revoke all page permissions">
              <i class="fa-solid fa-ban me-1"></i>
              {{ 'policy-management.revoke-all' | translate }}
            </button>
            <button type="button" class="btn btn-sm btn-outline-secondary action-btn" [disabled]="!hasUnsavedChanges"
              (click)="resetChanges()" title="Revert to last saved state">
              <i class="fa-solid fa-rotate-left me-1"></i>
              {{ 'policy-management.reset-changes' | translate }}
            </button>

            <!-- Grid vs Table View Mode -->
            <div class="btn-group view-switcher ms-1" role="group">
              <button type="button" class="btn btn-sm" [class.active]="viewMode === 'grid'" (click)="viewMode = 'grid'" title="Card Grid View">
                <i class="fa-solid fa-table-cells-large"></i>
              </button>
              <button type="button" class="btn btn-sm" [class.active]="viewMode === 'table'" (click)="viewMode = 'table'" title="Table List View">
                <i class="fa-solid fa-list"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- Module Category Tabs -->
        <div class="category-tabs-bar mt-3 pt-3 border-top" *ngIf="groups.length > 0">
          <button type="button" class="cat-chip" [class.active]="selectedGroup === 'all'"
            (click)="selectedGroup = 'all'; applyFilter()">
            All Modules ({{ totalCount }})
          </button>
          <button type="button" class="cat-chip" *ngFor="let g of groups"
            [class.active]="selectedGroup === g.name" (click)="selectedGroup = g.name; applyFilter()">
            {{ g.name }} ({{ g.count }})
          </button>
        </div>
      </div>

      <!-- Syncing Indicator (non-blocking) -->
      <div *ngIf="isLoadingPermissions && userPermissions.length > 0" class="d-flex align-items-center gap-2 mb-3 px-2 py-1 bg-light rounded" style="font-size: 12px; width: fit-content;">
        <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
        <span class="text-muted">Syncing user policies...</span>
      </div>

      <!-- Loading State only if no policies exist yet -->
      <div *ngIf="isLoadingPermissions && userPermissions.length === 0" class="text-center py-5">
        <div class="spinner-border text-primary" role="status" style="width: 2.5rem; height: 2.5rem;"></div>
        <h5 class="mt-3 text-muted" style="font-weight: 500;">Loading policy configuration...</h5>
      </div>

      <!-- Empty State -->
      <div *ngIf="!isLoadingPermissions && filteredPermissions.length === 0" class="text-center py-5">
        <div class="empty-icon-box mb-3">
          <i class="fa-solid fa-shield-slash"></i>
        </div>
        <h4 style="font-weight: 600; color: #101828;">No Policies Found</h4>
        <p class="text-muted mb-3" style="font-size: 13.5px;">No pages match your current search or filter criteria.</p>
        <button type="button" class="btn btn-outline-primary btn-sm px-3" (click)="searchTerm = ''; selectedGroup = 'all'; statusFilter = 'all'; applyFilter()">
          Reset Filters
        </button>
      </div>

      <!-- GRID VIEW -->
      <div *ngIf="filteredPermissions.length > 0 && viewMode === 'grid'" class="policy-grid-container mt-3">
        <div class="row g-3">
          <div class="col-xl-4 col-lg-6 col-md-6" *ngFor="let page of filteredPermissions">
            <div class="policy-card" [class.restricted-card]="!page.can_view" [class.allowed-card]="page.can_view">
              
              <!-- Top Row: Group Tag & Route -->
              <div class="d-flex align-items-center justify-content-between mb-3">
                <span class="module-tag">
                  <i class="fa-solid fa-folder me-1 text-muted"></i>
                  {{ page.group || 'General' }}
                </span>
                <span class="route-badge text-truncate" [title]="page.route">
                  {{ page.route || '-' }}
                </span>
              </div>

              <!-- Main Card Body -->
              <div class="d-flex align-items-start gap-3 mb-3">
                <div class="page-icon-wrapper" [class.allowed]="page.can_view" [class.restricted]="!page.can_view">
                  <i [class]="page.icon || 'fa-solid fa-file-lines'"></i>
                </div>
                <div class="flex-grow-1 text-truncate">
                  <h4 class="policy-page-title text-truncate" [title]="page.name">{{ page.name }}</h4>
                  <p class="policy-page-desc mb-0">
                    {{ page.description || ('Access and controls for ' + page.name + ' section in client panel.') }}
                  </p>
                </div>
              </div>

              <!-- Action Bar & Toggle Switch -->
              <div class="policy-card-footer d-flex align-items-center justify-content-between pt-3 border-top">
                <div class="status-indicator d-flex align-items-center gap-2">
                  <span class="status-dot" [class.allowed]="page.can_view" [class.restricted]="!page.can_view"></span>
                  <span class="status-text" [class.allowed]="page.can_view" [class.restricted]="!page.can_view">
                    {{ page.can_view ? ('policy-management.access-granted' | translate) : ('policy-management.access-restricted' | translate) }}
                  </span>
                </div>

                <div class="d-flex align-items-center gap-2">
                  <nz-switch [(ngModel)]="page.can_view" (ngModelChange)="applyFilter()"></nz-switch>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- TABLE VIEW -->
      <div *ngIf="filteredPermissions.length > 0 && viewMode === 'table'" class="policy-table-container mt-3">
        <div class="table-responsive">
          <table class="table align-middle policy-table">
            <thead>
              <tr>
                <th style="width: 50px;">#</th>
                <th>Page / Module</th>
                <th>Category</th>
                <th>Route Path</th>
                <th>Access Status</th>
                <th style="width: 120px;" class="text-end">Permission</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let page of filteredPermissions; let i = index" [class.table-restricted-row]="!page.can_view">
                <td class="text-muted" style="font-size: 12px;">{{ i + 1 }}</td>
                <td>
                  <div class="d-flex align-items-center gap-3">
                    <div class="page-icon-wrapper small" [class.allowed]="page.can_view" [class.restricted]="!page.can_view">
                      <i [class]="page.icon || 'fa-solid fa-file-lines'"></i>
                    </div>
                    <div>
                      <div class="table-page-name">{{ page.name }}</div>
                      <div class="table-page-sub text-muted">{{ page.slug }}</div>
                    </div>
                  </div>
                </td>
                <td>
                  <span class="module-tag">{{ page.group || 'General' }}</span>
                </td>
                <td>
                  <code class="route-code">{{ page.route }}</code>
                </td>
                <td>
                  <span class="status-pill" [class.allowed]="page.can_view" [class.restricted]="!page.can_view">
                    <i [class]="page.can_view ? 'fa-solid fa-check me-1' : 'fa-solid fa-lock me-1'"></i>
                    {{ page.can_view ? ('policy-management.access-granted' | translate) : ('policy-management.access-restricted' | translate) }}
                  </span>
                </td>
                <td class="text-end">
                  <nz-switch [(ngModel)]="page.can_view" (ngModelChange)="applyFilter()"></nz-switch>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>

    <!-- Sticky Bottom Bar when changes exist -->
    <div class="unsaved-sticky-banner shadow-lg" *ngIf="hasUnsavedChanges">
      <div class="d-flex align-items-center justify-content-between flex-wrap gap-3">
        <div class="d-flex align-items-center gap-3">
          <div class="unsaved-icon-badge">
            <i class="fa-solid fa-circle-exclamation"></i>
          </div>
          <div>
            <div style="font-weight: 700; font-size: 14px; color: #101828;">
              {{ 'policy-management.unsaved-warning' | translate }}
            </div>
            <div style="font-size: 12.5px; color: #475467;">
              Changes made for <strong>{{ selectedUser?.name || selectedUser?.email }}</strong>. Click "Save Policy" to enforce these access rights.
            </div>
          </div>
        </div>
        <div class="d-flex align-items-center gap-2">
          <button type="button" class="btn btn-outline-secondary btn-sm px-3" (click)="resetChanges()">
            {{ 'policy-management.discard' | translate }}
          </button>
          <button type="button" class="btn btn-primary btn-sm px-4" [disabled]="isSaving" (click)="savePolicy()">
            <span *ngIf="isSaving" class="spinner-border spinner-border-sm me-1"></span>
            <i *ngIf="!isSaving" class="fa-solid fa-floppy-disk me-1"></i>
            {{ (isSaving ? 'policy-management.saving' : 'policy-management.save-policy') | translate }}
          </button>
        </div>
      </div>
    </div>

  </div>
</div>
